import { useEffect, useState } from "react";
import FieldLoader from "../../../../components/UI/FieldLoader";
import PERMISSIONS from "../../../../utils/AclPermissions";
import Buttons from "../../../../components/UI/Buttons";
import { isSet } from "../../../../utils/commonUtils";
import FormInputs from "../../../../components/UI/FormInputs";
import EmrVisitsService from "../../../../services/EmrVisitsService";
import { createPortal } from "react-dom";
import Alert from "../../../../components/UI/ConfirmBox/Alert";

const NotesAlerts = (props) => {
  const [isLoading, setLoading] = useState(false);
  const [notes, setNotes] = useState("");
  const { visit_id, employeeId, selectedSubTab } = props;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  useEffect(() => {
    if (visit_id && selectedSubTab) {
      fetchNotes();
    }
  }, [visit_id, selectedSubTab]);
  const fetchNotes = async () => {
    setLoading(true);
    const response = await EmrVisitsService.getChartNotes(
      selectedSubTab,
      visit_id
    );
    const { data } = response;
    setLoading(false);
    setNotes(data?.note);
  };
  const handleUpdate = async (isClear = false, paramsNote = notes) => {
    const payload = {
      note: isClear ? "" : paramsNote,
      employee_id: employeeId,
    };
    setLoading(true);
    await EmrVisitsService.saveChartNotes(selectedSubTab, visit_id, payload);
    setLoading(false);
    if (isClear) {
      setShowDeleteModal(false);
    }
    fetchNotes();
  };
  const handleNotesChange = (value) => {
    setNotes(value);
  };
  const generateSummary = async () => {
    try{
    setLoading(true);
  
    const res = await EmrVisitsService.generateSummary(props.visit_id);
    setLoading(false);
    setNotes(`${res.processed_data}`);
    }catch(err){
      console.log(err);
      
    }

  }
  return (
    <>
      {showDeleteModal &&
        createPortal(
          <Alert
            onDelete={() => handleUpdate(true, "")}
            onClose={() => setShowDeleteModal(false)}
            content="Do you really want to Clear this record?"
          />,
          document.body
        )}
      <div className="sh_cardBody py-0" >
        <div className="sh_emrtextareabox p-1 position-relative">
          <Buttons
            className="btn mb-1 btn-primary"
            clickHandler={() => generateSummary(false, notes)}
            label={"Generate AI Summary"}
            acl={
              isSet(isLoading) === false
                ? PERMISSIONS.ANY_PERMISSION
                : PERMISSIONS.NO_PERMISSION
            }
          />
          <FieldLoader isLoading={isLoading} />
          <div className="d-flex align-items-center justify-content-between">
            <h5 className="text-sm font-weight-bold  mb-0">Notes & Alerts</h5>
            <div className="d-flex" style={{ gap: "5px" }}>
              <Buttons
                className="btn mb-1 btn-primary"
                clickHandler={() => handleUpdate(false, notes)}
                label={"Update"}
              />
              <Buttons
                acl={
                  isSet(notes, false)
                    ? PERMISSIONS.ANY_PERMISSION
                    : PERMISSIONS.NO_PERMISSION
                }
                className="btn mb-1 btn-secondary sh_btnlight"
                clickHandler={() => setShowDeleteModal(true)}
                label={"Clear All"}
              />
            </div>
          </div>
          <FormInputs
            type="Editor"
            value={notes}
            formats={{
              formats: ["background"],
            }}
            modules={{
              toolbar: [
                ["bold"],
                [{ background: ["yellow", "red", "green", "blue"] }],
                ["clean"],
              ],
            }}
            changeHandler={handleNotesChange}
            height={"680px"}
          />
        </div>
      </div>
    </>
  );
};

export default NotesAlerts;
